<script setup lang="ts">
import SearchInput from '../sections/SearchInput.vue';
import InsightModal from '../sections/InsightModal.vue';

interface InsightResult {
  type: 'users' | 'user' | 'calendar';
  title: string;
  meta: string;
  showExpand?: boolean;
}

interface Step {
  placeholder: string;
  ghost: string;
}

defineProps<{
  displayedText: string;
  isTyping: boolean;
  step: Step;
  results: InsightResult[];
}>();
</script>

<template>
  <div class="step-container">
    <SearchInput 
      :displayedText="displayedText" 
      :isTyping="isTyping"
      :placeholder="step.placeholder"
      :ghost="step.ghost"
    />
    
    <InsightModal 
      :displayedText="displayedText"
      :results="results"
      expanded
    />
  </div>
</template>

<style scoped>
.step-container { width: 100%; height: 100%; position: relative; }
</style>
